// hooks/useAppStartupMetrics.js
import { useEffect, useState } from 'react';

export const useAppStartupMetrics = () => {
  const [metrics, setMetrics] = useState({});

  useEffect(() => {
    // Esperar a que la pgina este completamente cargada
    if (document.readyState === 'complete') {
      captureMetrics();
    } else {
      window.addEventListener('load', captureMetrics);
      return () => window.removeEventListener('load', captureMetrics);
    }
  }, []);

  const captureMetrics = () => {
    const perfData = performance.getEntriesByType('navigation')[0];
    const paintEntries = performance.getEntriesByType('paint');

    // primer scrit: tiempo hasta que se carga el JS principal
    const firstScriptLoad = perfData.responseEnd - perfData.fetchStart;

    // React: tiempo hasta domContentLoadedEventEnd
    const frameworkInit =
      perfData.domContentLoadedEventEnd - perfData.fetchStart;

    // firstRender: First Contentful Paint
    const fcp = paintEntries.find(
      entry => entry.name === 'first-contentful-paint',
    );
    const firstRender = fcp ? fcp.startTime : null;

    // dataLoad: cuando termina de cargar todo
    const dataLoad = perfData.loadEventEnd - perfData.fetchStart;

    setMetrics({
      firstScriptLoad: Math.round(firstScriptLoad),
      frameworkInit: Math.round(frameworkInit),
      firstRender: Math.round(firstRender),
      dataLoad: Math.round(dataLoad),
    });
  };

  return metrics;
};
